export default {
  createdAt: 'Criado em',
  lastModifiedAt: 'Modificado em',
};
